(function() {
    if (typeof window.CustomEvent === "function") return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();


const $7037aa8d83eac4ad$var$reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const $7037aa8d83eac4ad$var$isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const $7037aa8d83eac4ad$var$concat = Function.bind.call(Function.call, Array.prototype.concat);
const $7037aa8d83eac4ad$var$keys = Reflect.ownKeys;
if (!Object.values) Object.values = function values(O) {
    return $7037aa8d83eac4ad$var$reduce($7037aa8d83eac4ad$var$keys(O), (v, k)=>$7037aa8d83eac4ad$var$concat(v, typeof k === "string" && $7037aa8d83eac4ad$var$isEnumerable(O, k) ? [
            O[k]
        ] : []), []);
};
if (!Object.entries) Object.entries = function entries(O) {
    return $7037aa8d83eac4ad$var$reduce($7037aa8d83eac4ad$var$keys(O), (e, k)=>$7037aa8d83eac4ad$var$concat(e, typeof k === "string" && $7037aa8d83eac4ad$var$isEnumerable(O, k) ? [
            [
                k,
                O[k]
            ]
        ] : []), []);
};


"use strict";


//# sourceMappingURL=provider-portal.b86e98f0.js.map
